
import HeroSection from './components/HeroSection';
import ProductsOverview from './components/ProductsOverview';

export default function ProductsPage() {
  return (
    <div>
      <HeroSection />
      <ProductsOverview />
    </div>
  );
}
